import script from "./WageLedgerManualModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageLedgerManualModal.vue?vue&type=script&setup=true&lang=ts"

import "./WageLedgerManualModal.vue?vue&type=style&index=0&id=ab4ad548&lang=css"

const __exports__ = script;

export default __exports__